<div *ngIf="propertyValue && propertyValue.newValue">
  {{propertyValue.newValue}}
  <mat-icon
    *ngIf="propertyValue.oldValue" 
    [matTooltip]="propertyValue.oldValue" 
    matTooltipPosition="right" [color]="'accent'" class="dataChangeIcon">info</mat-icon>
</div>